export const environment = {
  production: false,
  version: '1.0.1',    // <-- update this to build app with a new version number
  // apiBaseUrl: 'http://localhost:5209', // For Backend Developers

  //==================== Base URL For Development For Developers ========================

  // apiBaseUrl: 'http://192.168.29.68:7300', // Local backend For PC
  // // apiBaseUrl: 'http://192.168.29.80:7300', // Local backend For Frontend Developers Laptop 1

  //==================== For Testing Not For Developers ========================

  // apiBaseUrl: 'http://192.168.29.68:7200', // Local backend For PC
  // apiBaseUrl: 'http://192.168.29.80:7200', // Local backend For Frontend Developers Laptop 1

  imageBasePath: '/uploadeddocumentpath/',  // Common image path

  imageBasePathwithoutlogintoken: '/uploadeddocumentpathwithoutlogintoken/',  // Common image path

  // apiBaseUrl: 'https://dev.asapi.velocetech.space',  // ✅ Use old live backend

  // apiBaseUrl: 'https://test.api.ashasathi.com',  // ✅ Use Test backend

  apiBaseUrl: 'https://api.ashasathi.com',  // ✅ Use Test backend

  

};